import { Box } from '@factorialco/deprecated-design-system'
import { SectionHeader } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import { OfferLetterTemplatesTable } from './OfferLetterTemplates'

export const OfferLetterTemplates = () => {
  return (
    <Box paddingY="s24" gap="s24">
      <SectionHeader
        title={i18n.t('ats.settings.templates.offer_letter_templates.title')}
        description={i18n.t('ats.settings.templates.offer_letter_templates.description')}
      />

      <OfferLetterTemplatesTable />
    </Box>
  )
}
